module.exports = __webpack_public_path__ + "img/received.297b6525.png";